export default {
  methods: {
    isDisplayControl(name) {
      if (!this.controlRules) {
        return false;
      }
      return this.controlRules?.controls[name]?.display;
    },
    isReadonly(name) {
      if (!this.controlRules) {
        return false;
      }
      return this.controlRules?.controls[name]?.readonly;
    },
  }
};
